module.exports = __webpack_public_path__ + "img/Norman_and_Barry_Sheffield_Trident_Studios_open.original.d93404d7.jpg";